let callbacks = {}

const set = (type, callback) => (
  callbacks[type] = [callback, ...(callbacks[type] || [])]
)

const _blank = () => {}

const get = (type) => (
  callbacks[type] || [_blank]
)

const onMessage = ({data}) => {
  get(data.type).map(callback => callback(data.message))
}

export {
  get,
  onMessage
}

export default set


// WEBPACK FOOTER //
// ./src/communication-bridge/on.js